export default __webpack_public_path__ + "static/media/Char1.737f8161.png";